// Ursprungligen h�mtat fr�n https://jasonwatmore.com/post/2018/07/14/vue-vuex-user-registration-and-login-tutorial-example
// D�refter modifierat

import VueRouter from 'vue-router'

// Pages
import Home from '@/sietest/views/Home'

const routePrefix = ''; // '/basapp'

const routes = [
    {
        path: '*',
        redirect: { name: 'home' }
    },
    //{
    //    name: 'login',
    //    path: `${routePrefix}/login`,
    //    component: LoginPage
    //},
    //{
    //    name: 'register',
    //    path: `${routePrefix}/register`,
    //    component: RegisterPage
    //},

    //{
    //    name: 'users',
    //    path: `${routePrefix}/users`,
    //    component: UsersPage
    //},

    {
        name: 'home',
        path: `${routePrefix}/home`,
        component: Home
    },
    //{
    //    name: 'edit',
    //    path: `${routePrefix}/edit`,
    //    component: Edit,
    //    props: true,
    //},
    //{
    //    name: 'upload',
    //    path: `${routePrefix}/upload`,
    //    component: Upload
    //},
    //{
    //	name: 'account',
    //	props: { id: '1910' },
    //	path: `/${routePrefix}/account/:id`,
    //	component: Account
    //}
]

export const router = new VueRouter({
    mode: 'history',
    routes,
    linkActiveClass: 'is-active'
})

router.beforeEach((to, from, next) => {
    // redirect to login page if not logged in and trying to access a restricted page
    const publicPages = [`${routePrefix}/login`, `${routePrefix}/register`, `${routePrefix}/home`];
    const authRequired = !publicPages.includes(to.path);
    const loggedIn = localStorage.getItem('user');

    //console.log('beforeEach('+ to.path + ') authReuired='+ authRequired + ', loggedIn=' + loggedIn);

    //if (authRequired && !loggedIn) {
    //    return next(`/${routePrefix}/login`);
    //}

    next();
})